import { fetchFormDataGql } from './fetch-form-data-gql';
import { fetchJsonGql } from './fetch-json-gql';
import { fetchQueryParamsGql } from './fetch-query-params-gql';
import type { AssocMap, PersistedQuery } from './types';

interface FetchGqlArgs<GqlVariables = unknown> {
  query?: string;
  variables?: GqlVariables;
  assocMap?: AssocMap;
  persistedQuery?: PersistedQuery;
  preferGet?: boolean;
}

export const fetchGql = <GqlResponseData, GqlVariables = unknown>({
  query,
  variables,
  persistedQuery,
  assocMap,
  preferGet,
}: FetchGqlArgs<GqlVariables>) => {
  const extensions = persistedQuery ? { persistedQuery } : undefined;
  if (assocMap) {
    return fetchFormDataGql<GqlResponseData>({
      query,
      variables,
      assocMap,
      extensions,
    });
  }
  if (preferGet && extensions && !query) {
    return fetchQueryParamsGql<GqlResponseData>({
      variables,
      extensions,
    });
  } else {
    return fetchJsonGql<GqlResponseData>({
      query,
      variables,
      extensions,
    });
  }
};
